export const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:5001"
    : "https://chatapplication-backend-4nhj.onrender.com";